import React, { useCallback, useEffect, useState } from 'react';
import { interpolate, useAnimatedProps, useAnimatedRef, useAnimatedScrollHandler, useSharedValue, } from 'react-native-reanimated';
import EachSuggestion from 'design-system/suggestions/EachSuggestion';
import useAppFrameDimensions from 'hooks/useAppFrameDimensions';
const Suggestions = ({ suggestions, suggestedName, didUserAlterName, contentContainerStyle, handleSuggestionPress, oneLine, }) => {
    const scrollviewRef1 = useAnimatedRef();
    const scrollviewRef2 = useAnimatedRef();
    const ctx = useSharedValue(0);
    const scrollX1 = useSharedValue(0);
    const scrollX2 = useSharedValue(0);
    useEffect(() => {
        scrollX1.value = 0;
        scrollX2.value = 0;
        scrollviewRef1.current?.scrollTo({ x: 0, y: 0, animated: false });
        scrollviewRef2.current?.scrollTo({ x: 0, y: 0, animated: false });
    }, [scrollX1, scrollX2, suggestions, scrollviewRef1, scrollviewRef2]);
    const scrollHandler1 = useAnimatedScrollHandler({
        onBeginDrag: () => {
            ctx.value = 1;
        },
        onScroll: (event) => {
            scrollX1.value = event.contentOffset.x;
        },
    });
    const scrollHandler2 = useAnimatedScrollHandler({
        onBeginDrag: () => {
            ctx.value = 2;
        },
        onScroll: (event) => {
            scrollX2.value = event.contentOffset.x;
        },
    });
    const [scrollWidth1, setScrollWidth1] = useState(0);
    const [scrollWidth2, setScrollWidth2] = useState(0);
    const { width: WINDOW_WIDTH } = useAppFrameDimensions();
    const onContentSizeChange1 = useCallback((width) => {
        setScrollWidth1(width);
    }, []);
    const onContentSizeChange2 = useCallback((width) => {
        setScrollWidth2(width);
    }, []);
    const animatedProps1 = useAnimatedProps(() => {
        const max1 = scrollWidth1 - WINDOW_WIDTH;
        const max2 = scrollWidth2 - WINDOW_WIDTH;
        if (ctx.value === 1 ||
            suggestions[1].length === 0 ||
            !scrollWidth2 ||
            !scrollWidth1 ||
            max1 < 0 ||
            max2 < 0) {
            return {};
        }
        return {
            contentOffset: {
                x: interpolate(scrollX2.value, [-1, 0, max2, max2 + 1], [-1, 0, max1, max1 + 1]),
                y: 0,
            },
        };
    });
    const animatedProps2 = useAnimatedProps(() => {
        const max1 = scrollWidth1 - WINDOW_WIDTH;
        const max2 = scrollWidth2 - WINDOW_WIDTH;
        if (ctx.value === 2 ||
            !scrollWidth2 ||
            !scrollWidth1 ||
            max1 < 0 ||
            max2 < 0) {
            return {};
        }
        return {
            contentOffset: {
                x: interpolate(scrollX1.value, [-1, 0, max1, max1 + 1], [-1, 0, max2, max2 + 1]),
                y: 0,
            },
        };
    });
    const onSuggestionPress = useCallback((name, emoji) => () => {
        handleSuggestionPress(name, emoji);
    }, [handleSuggestionPress]);
    return (<>
      <EachSuggestion data={oneLine ? suggestions.flat() : suggestions[0]} onScroll={scrollHandler1} onPress={onSuggestionPress} animatedProps={animatedProps1} scrollViewRef={scrollviewRef1} didUserAlterName={didUserAlterName} suggestedName={suggestedName} onContentSizeChange={onContentSizeChange1} contentContainerStyle={contentContainerStyle}/>
      {!oneLine && (<EachSuggestion data={suggestions[1]} onScroll={scrollHandler2} onPress={onSuggestionPress} animatedProps={animatedProps2} scrollViewRef={scrollviewRef2} didUserAlterName={didUserAlterName} suggestedName={suggestedName} onContentSizeChange={onContentSizeChange2} contentContainerStyle={contentContainerStyle}/>)}
    </>);
};
export default React.memo(Suggestions);
